import { combineReducers } from 'redux';
import Goals from './index';

const rootReducer = combineReducers({
  Goals,
});

export default rootReducer;
